<template>
    <div :class="{ 'header-transparent-with-topbar': data.headerTransparency }">

        <!-- Start Header Area -->
        <header
            :class="[`rn-header header-default header-not-transparent header-sticky bg-transparent ${data.headerClass}`]">
            <div class="container position-relative">
                <div class="row align-items-center row--0">
                    <template v-if="data.navAlignment === 'right'">
                        <div class="col-lg-1 col-md-4 col-4">
                            <Logo />
                        </div>
                        <div class="col-lg-11 col-md-8 col-8 position-static">
                            <div class="header-right">
                                <nav class="mainmenu-nav d-none d-lg-block">
                                    <Nav />
                                </nav>

                                <!-- Start Header Btn -->
                                <div class="header-btn d-none d-lg-block" @click="orderShow">
                                    <a :class="data.buyButtonClass" href="#">
                                        预约演示
                                    </a>
                                </div>
                                <!-- End Header Btn  -->

                                <!-- Start Mobile-Menu-Bar -->
                                <div class="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <div class="hamberger">
                                        <button class="hamberger-button"
                                            @click.prevent="AppFunctions.toggleClass('.popup-mobile-menu', 'active')">
                                            <Icon name="menu" size="21" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Start Mobile-Menu-Bar 放大镜-->
                                <!-- <i class="bi bi-search search_header d-none d-lg-block"></i> -->

                            </div>
                        </div>
                    </template>
                    <template v-if="data.navAlignment === 'left'">
                        <div class="col-lg-9 col-md-6 col-4 position-static">
                            <div class="header-left d-flex">
                                <Logo />
                                <nav class="mainmenu-nav d-none d-lg-block">
                                    <Nav />
                                </nav>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-8">
                            <div class="header-right">
                                <!-- Start Header Btn -->
                                <div class="header-btn">
                                    <a :class="data.buyButtonClass">
                                        预约演示
                                    </a>
                                </div>
                                <!-- End Header Btn  -->

                                <!-- Start Mobile-Menu-Bar -->
                                <div class="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <div class="hamberger">
                                        <button class="hamberger-button"
                                            @click.prevent="AppFunctions.toggleClass('.popup-mobile-menu', 'active')">
                                            <Icon name="menu" size="21" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Start Mobile-Menu-Bar 放大镜-->
                                <div class="my_switcher">
                                    放大镜
                                </div>

                                <!-- <div v-if="data.showThemeSwitcherButton" id="my_switcher" class="my_switcher">
                                    <ul>
                                        <li>
                                            <a href="javascript: void(0);"
                                               @click.prevent="AppFunctions.toggleClass('body', 'active-light-mode')">
                                                <img class="light-icon"
                                                     src="../../../assets/images/icons/sun-01.svg"
                                                     alt="Sun images">
                                                <img class="dark-icon"
                                                     src="../../../assets/images/icons/vector.svg"
                                                     alt="Moon Images">
                                            </a>
                                        </li>
                                    </ul>
                                </div> -->
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </header>
        <!-- End Header Area -->

        <!-- Start Mobile Menu -->
        <MobileMenu />
        <!-- End Mobile Menu -->
        <div class="order-show" v-if="shows">
            <order-show @close="close"></order-show>
        </div>
        <!-- Start Theme Style -->
        <div>
            <div class="rn-gradient-circle" />
            <div class="rn-gradient-circle theme-pink" />
        </div>
        <!-- End Theme Style -->
    </div>
</template>
<style lang="scss">
.order-show {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: rgba($color: #999, $alpha: 0.9);
}
</style>
<script>
import Icon from '../../icon/Icon'
import MobileMenu from './MobileMenu'
import AppFunctions from '../../../helpers/AppFunctions'
import Nav from './Nav'
import Logo from '../../elements/logo/Logo'
import OrderShow from '../dialog/orderShow.vue'
export default {
    name: 'Header',
    props: {
        data: {
            default: null
        }
    },
    components: { Logo, Nav, MobileMenu, Icon, OrderShow },
    data() {
        return {
            AppFunctions,
            shows: false
        }
    },
    methods: {
        toggleStickyHeader() {
            const scrolled = document.documentElement.scrollTop;
            if (scrolled > 100) {
                AppFunctions.addClass('.header-default', 'sticky');
            } else if (scrolled <= 100) {
                AppFunctions.removeClass('.header-default', 'sticky');
                if (this.$route.name != 'Home') {
                    AppFunctions.addClass('.header-default', 'sticky');
                }
            }
        },
        orderShow() {
            console.log(1111);
            this.shows = true
        },
        close(){
            this.shows = false
        }
    },
    created() {
        window.addEventListener('scroll', this.toggleStickyHeader);
    },
    mounted() {
        // this.AppFunctions.toggleClass('body', 'active-light-mode')
        this.toggleStickyHeader();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.toggleStickyHeader);
    }
}
</script>